import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router'
import { AuthService, MsalUserGuardService } from '@appShared/services'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'
import { of } from 'rxjs'

export const PublicOnlyGuardService: CanActivateFn = (
   route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot
) => {

   const authService = inject(AuthService)
   const redirectUrl = authService.redirectUrl() || `/${SITE_DIRECTORY_ROUTES.content.uri}`
   return inject(MsalUserGuardService).msalNonAuthenticated(redirectUrl)
}
